import { render, staticRenderFns } from "./SeminarEntryDisplayTarget.vue?vue&type=template&id=73b97854"
import script from "./SeminarEntryDisplayTarget.vue?vue&type=script&lang=js"
export * from "./SeminarEntryDisplayTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports